import { CrossInFilledCircle, CheckInCircleActive } from "assets/icons";
import classNames from "classnames";
import { IconButton, Input } from "ui";

import { LocationInputProps } from "../DeliveryLocationColumn.types";

import styles from "../DeliveryLocationColumn.module.scss";

export const LocationInput = ({
  value,
  isConfirmDisabled,
  onCrossClick,
  onConfirm,
  onChange
}: LocationInputProps) => {
  return (
    <div className={styles.locationInputContainer}>
      <Input
        value={value}
        autoFocus
        onChange={onChange}
        className={styles.locationInput}
      />

      <IconButton
        icon={<CrossInFilledCircle fill={"#A8A8BB"} />}
        onClick={onCrossClick}
        className={styles.locationInput_cancelBtn}
      />

      <IconButton
        icon={
          <CheckInCircleActive
            color={isConfirmDisabled ? "#A8A8BB" : "#16C350"}
          />
        }
        disabled={isConfirmDisabled}
        onClick={onConfirm}
        className={classNames(styles.locationInput_confirmBtn, {
          [styles.locationInput_confirmBtn__disabled]: isConfirmDisabled
        })}
      />
    </div>
  );
};
